import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { actions as viewchallenge } from 'viewchallenge';
import { getViewChallengeErrors, getApiPollingTimeInterval, getViewChallengeRequestPayload, getViewAmbasssadorProfileRequestPayload } from '../selectors';
import { ViewChallengeApi } from '../requests';
import { NetworkRequestResponse, network } from '@imodules/helix';



export const initiateViewChallengeDataPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        while ((getViewChallengeErrors(getState()) ?? 0) < 5) {
            const request = dispatch(pollChallenge());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            let timeInterval: number = getApiPollingTimeInterval(getState()) ?? 1000;
            if (timeInterval === undefined) {
                timeInterval = 1000; // Default value
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollChallenge = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const payload = getViewChallengeRequestPayload(getState());
        dispatch(await makeChallengeRequest(payload));
    };
};

export const makeChallengeRequest = (payload: ViewChallengeRequestPayload): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        try {
            const request = ViewChallengeApi.createGetRequest(payload.challengeId, payload.parentFormId, payload.initiativeId);
            if (!request) {
                throw new Error("Failed to create request object.");
            }
            const tempResult = await network.call(request);
            if (tempResult === undefined) {
                throw new Error("Network request failed to return a valid response.");
            }
            const result: NetworkRequestResponse<ViewChallengeDataRecord> = tempResult as NetworkRequestResponse<ViewChallengeDataRecord>;
            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(viewchallenge.getChallengeSettings(result.response.content));
                if (result.response.content != null) {
                    const ambassadorPayload = getViewAmbasssadorProfileRequestPayload(getState());
                    const ambassadorRequest = ViewChallengeApi.createAmbassadorGetRequest(ambassadorPayload?.AmbssadorId);
                    const ambassadorResult: any = await network.call(ambassadorRequest);
                    if (ambassadorResult.error) {
                        dispatch(actions.apiCallFailure(ambassadorResult.error.message));
                    } else {
                        dispatch(viewchallenge.populateAmbassadorProfile(ambassadorResult.response.content));
                        dispatch(actions.apiCallSuccess());
                    }
                }
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const watchGetChallengeViewData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateViewChallengeDataPolling());
    };
};